import {history} from 'client/history';

import {showGlobalModal} from '@albert-io/atomic';

import {local} from 'lib/StorageUtil';
import {isSafeRedirectPath} from 'lib/isSafeRedirectPath';

import LogInModal from './LogInModal.react';

export const LOG_IN_PAGE_BASE_PATH = '/log-in';

export function redirectToLoginPageFromLocation() {
  const {pathname, search} = history.getCurrentLocation();
  const attemptedPath = `${pathname}${search ?? ''}`;
  // Persist the deep link the user was bounced from so UserRedirectUtil can return
  // them to it after login — but never the log-in page itself (would loop).
  if (pathname !== LOG_IN_PAGE_BASE_PATH && isSafeRedirectPath(attemptedPath)) {
    local.set('postLoginRedirect', attemptedPath);
  }
  // Re-replacing the login page with itself churns the router mid-transition (#185 fuel).
  if (pathname !== LOG_IN_PAGE_BASE_PATH) {
    history.replaceState(null, LOG_IN_PAGE_BASE_PATH);
  }
}

export function hardRedirectToLoginPage() {
  global.document.location = LOG_IN_PAGE_BASE_PATH;
}

export function showGlobalLoginModal() {
  showGlobalModal(LogInModal);
}
